import "./topbar.scss";
import { Person, Mail } from "@material-ui/icons";

export default function Topbar({ menuOpen, setMenuOpen }) {
  return (
    <div className={"topbar " + (menuOpen && "active")}>
      <div className="wrapper">
   
        <div className="left">
          <div className="hamburger" onClick={()=>setMenuOpen(!menuOpen)}>
            <span className="line1"></span>
            <span className="line2"></span>
            <span className="line3"></span>
          </div>
        </div>
        <div className="right">
          <a href="#intro" className="logo">
          iT-rex 22.
          </a>
          <div className="itemContainer">
            <Person className="icon" />
            <span>+1(510) 695-6264</span>
          </div>
          <div className="itemContainer">
            <Mail className="icon" />
            <span>angel3322ronald@gmail.com</span>
          </div>
        </div>
      </div>
    </div>
  );
}
